const prefix = 'USER/';
const USER_ME_TAG = `${prefix}ME`;

export const LOGIN_INFO_TAG = `${prefix}LOGIN_INFO`;

export default USER_ME_TAG;
